export const aboutGalleryImages = [
  'athens1.jpg', 'athens2.jpg', 'athens3.jpg', 'athens4.jpg', 'athens5.jpg',
  'athens6.jpg', 'athens7.jpg', 'athens8.jpg', 'athens9.jpg', 'athens10.jpg',
  'athens11.jpg', 'athens12.jpg', 'athens13.jpg', 'athens14.jpg', 'athens15.jpg',
  'beijing1.jpg',
  'hongkong1.jpg', 'hongkong2.jpg', 'hongkong3.jpg', 'hongkong4.jpg',
  'hongkong5.jpg', 'hongkong6.jpg', 'hongkong7.jpg', 'hongkong8.jpg',
  'hkdisney1.jpg', 'hkdisney2.jpg', 'hkdisney3.jpg', 'hkdisney4.jpg', 'hkdisney5.jpg',
  'napier1.jpg', 'rotorua1.jpg', 'shanghai1.jpg', 'shanghai2.jpg', 'tainan1.jpg',
  'tw1.jpeg', 'tw2.jpeg', 'tw3.jpeg', 'tw4.jpeg', 'tw5.jpeg', 'tw6.jpeg',
  'tw7.jpg', 'tw8.jpg',
  'syd1.jpg', 'syd2.jpg', 'syd3.jpg', 'syd5.jpeg', 'syd6.jpeg', 'syd7.jpeg',
  'syd8.jpeg', 'syd9.jpg', 'syd10.jpg', 'syd11.jpg',
  'gc1.jpeg', 'gc2.jpeg', 'gc3.jpeg', 'gc4.jpeg', 'gc5.jpeg', 'gc6.jpg', 'gc7.jpg',
];

// The gallery lays images out at a fixed height, so their intrinsic aspect
// ratios determine the width of the horizontal rail. Keeping those ratios in
// the markup prevents lazy images from changing the rail geometry while a
// touch scroll is decelerating or snapping into place.
const aboutGalleryDimensions = {
  'athens1.jpg': [960, 1280],
  'athens2.jpg': [1280, 960],
  'athens3.jpg': [960, 1280],
  'athens4.jpg': [1280, 960],
  'athens5.jpg': [1280, 853],
  'athens6.jpg': [1280, 853],
  'athens7.jpg': [1280, 853],
  'athens8.jpg': [1280, 720],
  'athens9.jpg': [1280, 720],
  'athens10.jpg': [1280, 720],
  'athens11.jpg': [1280, 720],
  'athens12.jpg': [1280, 720],
  'athens13.jpg': [1280, 720],
  'athens14.jpg': [1280, 720],
  'athens15.jpg': [1280, 720],
  'beijing1.jpg': [1280, 960],
  'hongkong1.jpg': [1280, 853],
  'hongkong2.jpg': [853, 1280],
  'hongkong3.jpg': [1280, 853],
  'hongkong4.jpg': [1280, 853],
  'hongkong5.jpg': [1280, 853],
  'hongkong6.jpg': [1280, 853],
  'hongkong7.jpg': [1280, 853],
  'hongkong8.jpg': [1280, 1048],
  'hkdisney1.jpg': [1280, 853],
  'hkdisney2.jpg': [853, 1280],
  'hkdisney3.jpg': [853, 1280],
  'hkdisney4.jpg': [1280, 853],
  'hkdisney5.jpg': [1280, 853],
  'napier1.jpg': [1280, 960],
  'rotorua1.jpg': [1280, 960],
  'shanghai1.jpg': [853, 1280],
  'shanghai2.jpg': [1280, 853],
  'tainan1.jpg': [1280, 960],
  'tw1.jpeg': [1280, 960],
  'tw2.jpeg': [1280, 960],
  'tw3.jpeg': [1280, 960],
  'tw4.jpeg': [1280, 960],
  'tw5.jpeg': [1280, 960],
  'tw6.jpeg': [1280, 960],
  'tw7.jpg': [1280, 960],
  'tw8.jpg': [1280, 874],
  'syd1.jpg': [960, 1280],
  'syd2.jpg': [1280, 960],
  'syd3.jpg': [1280, 960],
  'syd5.jpeg': [1280, 960],
  'syd6.jpeg': [1280, 960],
  'syd7.jpeg': [960, 1280],
  'syd8.jpeg': [960, 1280],
  'syd9.jpg': [960, 1280],
  'syd10.jpg': [719, 1280],
  'syd11.jpg': [720, 1280],
  'gc1.jpeg': [1280, 960],
  'gc2.jpeg': [1280, 960],
  'gc3.jpeg': [1280, 960],
  'gc4.jpeg': [953, 1280],
  'gc5.jpeg': [1280, 1278],
  'gc6.jpg': [1280, 960],
  'gc7.jpg': [960, 1280],
};

export function aboutGallerySize(filename) {
  return aboutGalleryDimensions[filename] || [4, 3];
}

export function aboutGalleryPreview(filename) {
  return `/assets/gallery/previews/${filename}.webp`;
}

export function aboutGalleryFull(filename) {
  return `/assets/gallery/${filename}`;
}

// Keep the archived gallery intact. The current Travels gallery omits the
// lotus photograph and opens on a short sequence across different places.
const travelOpening = ['napier1.jpg', 'tw3.jpeg', 'athens7.jpg', 'hongkong1.jpg', 'syd2.jpg'];
export const travelGalleryImages = [
  ...travelOpening,
  ...aboutGalleryImages.filter(name => name !== 'tainan1.jpg' && !travelOpening.includes(name)),
];

export function pickHomeGalleryImages() {
  const images = [...travelGalleryImages];
  for (let i = images.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [images[i], images[j]] = [images[j], images[i]];
  }
  return images.slice(0, 8);
}
